var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizactionicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9242_35246",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H22V22H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9242_35246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9336 2.57812C12.9336 3.64603 12.0679 4.51172 11 4.51172C9.9321 4.51172 9.06641 3.64603 9.06641 2.57812C9.06641 1.51022 9.9321 0.644531 11 0.644531C12.0679 0.644531 12.9336 1.51022 12.9336 2.57812Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67316 5.11448C5.59798 5.64841 5.91487 6.83095 5.3809 7.75581C4.84697 8.68062 3.66438 8.99748 2.73957 8.4635C1.81475 7.92962 1.4979 6.74703 2.03183 5.82221C2.5658 4.89735 3.74834 4.5805 4.67316 5.11448Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73957 13.5364C3.66438 13.0024 4.84697 13.3192 5.3809 14.2441C5.91487 15.1689 5.59798 16.3515 4.67316 16.8854C3.74834 17.4194 2.5658 17.1025 2.03183 16.1777C1.4979 15.2528 1.81475 14.0703 2.73957 13.5364Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06641 19.4219C9.06641 18.354 9.9321 17.4883 11 17.4883C12.0679 17.4883 12.9336 18.354 12.9336 19.4219C12.9336 20.4898 12.0679 21.3555 11 21.3555C9.9321 21.3555 9.06641 20.4898 9.06641 19.4219Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3267 16.8854C16.4019 16.3514 16.0851 15.1689 16.619 14.244C17.1529 13.3192 18.3355 13.0024 19.2603 13.5364C20.1851 14.0702 20.502 15.2528 19.9681 16.1776C19.4341 17.1025 18.2515 17.4194 17.3267 16.8854Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2603 8.4635C18.3355 8.99748 17.1529 8.68063 16.619 7.75577C16.0851 6.83095 16.4019 5.64836 17.3267 5.11448C18.2515 4.5805 19.4341 4.89736 19.9681 5.82217C20.502 6.74703 20.1851 7.92957 19.2603 8.4635Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07888 2.79831C7.43502 3.18189 5.97619 4.0469 4.85913 5.23657",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93643 8.56276C2.44667 10.1782 2.46635 11.8741 2.93815 13.4363",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85767 16.7647C6.01176 17.9965 7.49028 18.8274 9.07913 19.2",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9211 19.2019C14.565 18.8183 16.0238 17.9533 17.1409 16.7636",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0635 13.4373C19.5532 11.8218 19.5335 10.126 19.0618 8.56374",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1423 5.23535C15.9883 4.00352 14.5097 3.17264 12.9209 2.8001",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7187 8.80859C12.7187 9.75786 11.9493 10.5273 11 10.5273C10.0508 10.5273 9.28125 9.75786 9.28125 8.80859C9.28125 7.85933 10.0508 7.08984 11 7.08984C11.9493 7.08984 12.7187 7.85933 12.7187 8.80859Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.793 14.9102H8.20703V12.0312C8.20703 11.2007 8.88035 10.5273 9.71094 10.5273H12.2891C13.1196 10.5273 13.793 11.2007 13.793 12.0312V14.9102Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizactionicon);
export default __webpack_public_path__ + "static/media/organizactionicon.23257be6f161599c0464aabfc8a142ac.svg";
export { ForwardRef as ReactComponent };